import { useQuery, UseQueryResult } from "react-query";
import { ExtractionImage } from "./types";
import { get } from "./api";

export default function useGetExtractionImages(importId: string): UseQueryResult<{ [key: string]: ExtractionImage }> {
  return useQuery(["extractionImages", importId], () => (importId ? getExtractionImages(importId) : {}));
}

async function getExtractionImages(importId: string): Promise<{ [key: string]: ExtractionImage }> {
  const response = await get(`extraction/${importId}/images`);

  if (!response.ok) throw response.error;

  return response.data;
}
